import React, { Component } from "react";
import BarLoader from "react-bar-loader";
import {
  Alert,
  Button,
  Col,
  ControlLabel as FormLabel,
  Form,
  FormControl,
  FormGroup
} from "react-bootstrap";

import logo from "assets/img/reactlogo.svg";
import ViewportAlert from "components/ViewportAlert/ViewportAlert";

const API_BASE = "https://hgsystem.pl/mangusta";

function getPasswordLinkContext() {
  const hash = window.location.hash || "";
  const hashQuery = hash.split("?")[1] || "";
  const parameters = new URLSearchParams(hashQuery);
  const token = parameters.get("token") || "";
  const login = parameters.get("login") || "";
  if (!token) return { mode: "login", token: "", login };
  return {
    mode: hash.indexOf("#/invite") === 0 ? "invite" : "reset",
    token,
    login: ""
  };
}

class Login extends Component {
  constructor(props) {
    super(props);
    const passwordLink = getPasswordLinkContext();

    this.state = {
      mode: passwordLink.mode,
      resetToken: passwordLink.token,
      login: passwordLink.login,
      password: "",
      identifier: "",
      invitationLogin: "",
      newPassword: "",
      confirmPassword: "",
      loginError: false,
      message: "",
      error: "",
      loader: false
    };
  }

  componentDidMount() {
    window.addEventListener("hashchange", this.syncPasswordLink);
    if (this.state.mode === "invite" && this.state.resetToken)
      this.loadInvitationDetails(this.state.resetToken);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.syncPasswordLink);
  }

  syncPasswordLink = () => {
    const passwordLink = getPasswordLinkContext();
    if (passwordLink.token) {
      this.setState(
        {
          mode: passwordLink.mode,
          resetToken: passwordLink.token,
          invitationLogin: "",
          error: "",
          message: ""
        },
        () => {
          if (passwordLink.mode === "invite")
            this.loadInvitationDetails(passwordLink.token);
        }
      );
    } else if (passwordLink.login) {
      this.setState({
        mode: "login",
        resetToken: "",
        login: passwordLink.login,
        identifier: passwordLink.login,
        error: "",
        message: ""
      });
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      loginError: false,
      error: ""
    });
  };

  post = (endpoint, body) =>
    fetch(`${API_BASE}/${endpoint}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then(async response => {
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.error || "Wystąpił błąd serwera");
      return data;
    });

  loadInvitationDetails = token => {
    this.setState({ loader: true, error: "" });
    this.post("user_invitation_details.php", { token })
      .then(data =>
        this.setState({
          invitationLogin: data.login || "",
          loader: false
        })
      )
      .catch(error =>
        this.setState({
          invitationLogin: "",
          loader: false,
          error: error.message
        })
      );
  };

  handleLogin = event => {
    event.preventDefault();
    if (!this.state.login || !this.state.password) return;

    this.setState({ loader: true, loginError: false, error: "" });
    this.post("login2.php", {
      login: this.state.login,
      haslo: this.state.password,
      firstTime: true
    })
      .then(data => {
        if (data.user) {
          this.props.onLogin(data, {
            session_token: data.session_token
          });
          return;
        }
        this.setState({ loginError: true, loader: false });
      })
      .catch(error =>
        this.setState({ loader: false, error: error.message })
      );
  };

  requestPasswordReset = event => {
    event.preventDefault();
    if (!this.state.identifier) return;

    this.setState({ loader: true, error: "", message: "" });
    this.post("request_password_reset.php", {
      identifier: this.state.identifier
    })
      .then(data =>
        this.setState({
          loader: false,
          message: data.message,
          identifier: ""
        })
      )
      .catch(error =>
        this.setState({ loader: false, error: error.message })
      );
  };

  resetPassword = event => {
    event.preventDefault();
    if (this.state.newPassword.length < 10) {
      this.setState({ error: "Hasło musi mieć co najmniej 10 znaków." });
      return;
    }
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ error: "Podane hasła nie są identyczne." });
      return;
    }

    const invitationMode = this.state.mode === "invite";
    this.setState({ loader: true, error: "", message: "" });
    this.post(
      invitationMode
        ? "accept_user_invitation.php"
        : "reset_password.php",
      {
      token: this.state.resetToken,
      password: this.state.newPassword
      }
    )
      .then(data => {
        window.location.hash = "#/";
        this.setState({
          mode: "login",
          resetToken: "",
          invitationLogin: "",
          newPassword: "",
          confirmPassword: "",
          loader: false,
          message: data.message
        });
      })
      .catch(error =>
        this.setState({ loader: false, error: error.message })
      );
  };

  showLogin = () => {
    window.location.hash = "#/";
    this.setState({
      mode: "login",
      resetToken: "",
      invitationLogin: "",
      error: "",
      message: ""
    });
  };

  renderLoginForm() {
    return (
      <Form onSubmit={this.handleLogin}>
        {this.state.loginError && (
          <Alert bsStyle="danger">Błędne dane logowania</Alert>
        )}
        <FormGroup controlId="login" bsSize="large">
          <FormLabel>Login</FormLabel>
          <FormControl
            autoFocus
            value={this.state.login}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <FormLabel>Hasło</FormLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <div className="text-center">
          <Button
            bsSize="large"
            type="submit"
            disabled={!this.state.login || !this.state.password}
          >
            Zaloguj
          </Button>
          <div style={{ marginTop: 15 }}>
            <Button
              bsStyle="link"
              onClick={() =>
                this.setState({
                  mode: "request",
                  identifier: this.state.login,
                  error: "",
                  message: ""
                })
              }
            >
              Nie pamiętasz hasła?
            </Button>
          </div>
        </div>
      </Form>
    );
  }

  renderRequestForm() {
    return (
      <Form onSubmit={this.requestPasswordReset}>
        <h4>Odzyskiwanie hasła</h4>
        <p>
          Podaj login albo adres e-mail przypisany do konta. Wyślemy link
          ważny przez 60 minut.
        </p>
        <FormGroup controlId="identifier" bsSize="large">
          <FormLabel>Login lub e-mail</FormLabel>
          <FormControl
            autoFocus
            value={this.state.identifier}
            onChange={this.handleChange}
          />
        </FormGroup>
        <div className="text-center">
          <Button
            bsSize="large"
            type="submit"
            disabled={!this.state.identifier || this.state.loader}
          >
            Wyślij link
          </Button>
          <Button bsStyle="link" onClick={this.showLogin}>
            Wróć do logowania
          </Button>
        </div>
      </Form>
    );
  }

  renderResetForm() {
    const invitationMode = this.state.mode === "invite";
    return (
      <Form onSubmit={this.resetPassword}>
        <h4>
          {invitationMode
            ? "Aktywuj konto Mangusta24"
            : "Ustaw nowe hasło"}
        </h4>
        <p>
          {invitationMode
            ? "Ustaw własne hasło, aby aktywować konto. Hasło musi mieć co najmniej 10 znaków."
            : "Nowe hasło musi mieć co najmniej 10 znaków."}
        </p>
        {invitationMode && (
          <FormGroup controlId="invitationLogin" bsSize="large">
            <FormLabel>Login</FormLabel>
            <FormControl
              type="text"
              name="username"
              autoComplete="username"
              value={this.state.invitationLogin}
              readOnly
            />
          </FormGroup>
        )}
        <FormGroup controlId="newPassword" bsSize="large">
          <FormLabel>Nowe hasło</FormLabel>
          <FormControl
            autoFocus
            type="password"
            name="new-password"
            autoComplete="new-password"
            value={this.state.newPassword}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <FormLabel>Powtórz nowe hasło</FormLabel>
          <FormControl
            type="password"
            name="confirm-password"
            autoComplete="new-password"
            value={this.state.confirmPassword}
            onChange={this.handleChange}
          />
        </FormGroup>
        <div className="text-center">
          <Button
            bsSize="large"
            type="submit"
            disabled={
              !this.state.newPassword ||
              !this.state.confirmPassword ||
              (invitationMode && !this.state.invitationLogin) ||
              this.state.loader
            }
          >
            {invitationMode ? "Aktywuj konto" : "Zmień hasło"}
          </Button>
          <Button bsStyle="link" onClick={this.showLogin}>
            Anuluj
          </Button>
        </div>
      </Form>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="logo-img simple-text logo-normal text-center">
          <img
            src={logo}
            alt="Mangusta24"
            style={{ height: 40, margin: 20 }}
          />
        </div>
        <div className="container" style={{ padding: 30 }}>
          <Col lg={3} sm={2} />
          <Col lg={6} sm={8}>
            {this.state.error && (
              <ViewportAlert
                bsStyle="danger"
                onDismiss={() => this.setState({ error: "" })}
              >
                {this.state.error}
              </ViewportAlert>
            )}
            {this.state.message && (
              <ViewportAlert
                bsStyle="success"
                onDismiss={() => this.setState({ message: "" })}
              >
                {this.state.message}
              </ViewportAlert>
            )}
            {this.state.mode === "login" && this.renderLoginForm()}
            {this.state.mode === "request" && this.renderRequestForm()}
            {(this.state.mode === "reset" ||
              this.state.mode === "invite") &&
              this.renderResetForm()}
            {this.state.loader && (
              <div className="sweet-loading">
                <BarLoader color="#1D8BF1" height="2" />
              </div>
            )}
          </Col>
          <Col lg={3} sm={2} />
        </div>
      </React.Fragment>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx